export const list = [
  {
    label: '技术使命',
    content: '为候选人提供真正公平的技能认证，给企业反馈真实可信赖的甄选报告'
  },
  { label: '发展愿景', content: '甄选真正的人才，推荐适合的人才' },
  { label: '品牌文化', content: '丈量，不可估量的未来！' }
]



// WEBPACK FOOTER //
// ./src/components/about/about-top-cell/config.js